import { Component, OnInit, Inject, Renderer2 } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { LayoutService } from "../services/layout.service";
import { JwtHelperService } from "@auth0/angular-jwt";
import { SharedService } from "src/app/shared/services/shared.service";
import { DataSharingService } from "src/app/shared/services/data-sharing.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { CreateProjectComponent } from "../../project/component/create-project/create-project.component";
import { environment } from "src/environments/environment";

interface City {
  name: string;
  code: string;
}

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  public fullscreen = false;
  public selectedItem: any;

  public selectedCity: City;
  public helper: JwtHelperService;
  public userName: string;
  public userEmail: string;
  public imageText: string;

  public alerts;
  public PushObject;
  public firstLoad = true;
  public Items: any;
  public getId: any;
  public contentLoader = false;
  localStorageAlice = localStorage;
  projectName: string = environment.projectName;

  constructor(
    private router: Router,
    private _LayoutDataService: LayoutService,
    private _SharedService: SharedService,
    public _dataSharingService: DataSharingService,
    @Inject(DOCUMENT) private document: Document,
    private dialog: MatDialog
  ) {
    this.helper = new JwtHelperService();
    this.getAllProjects();
  }
  ngOnInit() {
    if (
      this.helper.isTokenExpired(
        localStorage.getItem(this.projectName + "token")
      ) ||
      !localStorage.getItem(this.projectName + "token")
    ) {
      this.router.navigate(["/auth/login"]);
    }
    // this.getAllProjects();
    this.selectedItem = localStorage.getItem("projectName");
    let token = this.helper.decodeToken(
      localStorage.getItem(this.projectName + "token")
    );
    this.userName = token.firstName + " " + token.lastName;
    this.userEmail = token.email;
    this.imageText = token.firstName.charAt(0) + "" + token.lastName.charAt(0);
    // this._LayoutDataService._comp1ValueBS.subscribe((element) => {
    //   this.PushObject = element;
    //   console.log(element);
    // });
    // this._LayoutDataService
    //   .getAllAlertLevel("eq", "isSeen", "false")
    //   .subscribe((res) => {
    //     this.alerts = res.body["data"];
    //   });
    // this.getAllProjects();
    // // this.usersDataService.details().subscribe(data => {
    // //     this.user = data.body as IUser;
    // // });
    // let obj = {
    //   link: "test",
    //   name: "Menu",
    //   icon: "ti-marker",
    //   description: "this is testing search",
    // };
    // // this.menuFind.push(obj);
    // let obj1 = {
    //   link: "test",
    //   name: "Submenu",
    //   icon: "ti-marker",
    //   description: "this is testing search",
    // };
    // // this.menuFind.push(obj1);
    // setInterval(() => {
    //   this._LayoutDataService
    //     .getAllAlertLevel("eq", "isSeen", "false")
    //     .subscribe((res) => {
    //       this.alerts = res.body["data"];
    //     });
    // }, 300000);
  }

  getAllProjects() {
    this._LayoutDataService.getAllProject().subscribe((res) => {
      this.Items = res.body["data"];
      console.log("i found items ", this.Items);
      // this.localStorageAlice.clear();

      if (localStorage.getItem("projectId") == null) {
        console.log("i found items projectId if  ");

        this.getId = this.Items[0]?.id;
        localStorage.setItem("projectId", this.getId);
      } else {
        this.getId = JSON.parse(localStorage.getItem("projectId"));
      }
      this._SharedService.isProjectsLoaded = true;
      if (this.router.url == "/") {
        this.router.navigate(["/dashboard"]);
      }
    });
  }

  onSelectProject(event) {
    if (event) {
      this.selectedItem = event.value.name;
      let projectId = event.value.id;
      let projectName = event.value.name;
      console.log("project id in navbar>>>", projectId);

      localStorage.setItem("projectId", projectId);

      if (localStorage.getItem("projectId") == null) {
        if (this.firstLoad) {
          // this.firstLoad = false;
          // console.log("Event", event);
          localStorage.setItem("projectId", projectId);
          localStorage.setItem("projectName", projectName);
        } else {
          this.firstLoad = false;
        }
      } else {
        if (this.firstLoad) {
          this.firstLoad = false;
          localStorage.setItem("projectId", projectId);
          localStorage.setItem("projectName", projectName);
        } else {
          this.firstLoad = false;
          // console.log("Event", event);
          localStorage.setItem("projectId", projectId);
          localStorage.setItem("projectName", projectName);
          // window.location.reload();
        }
      }
    }

    if (this.router.url.includes("dashboard")) {
      this.router.navigate(["/dashboard"]);
      this._LayoutDataService.dashboardReload.next(event);
    } else if (this.router.url.includes("templates")) {
      this.router.navigate(["/templates"]);
      this._LayoutDataService.templatesReload.next(event);
    } else if (this.router.url.includes("things")) {
      this.router.navigate(["/things-manager"]);
      this._LayoutDataService.thingsReload.next(event);
    } else {
      this._LayoutDataService.dashboardReload.next(event);
    }

    // this.router.navigate(['dashboard']);

    // window.location.reload();
  }
  // signOut(e) {
  //   e.preventDefault();
  //   localStorage.removeItem("token");
  //   this.router.navigate(["/sso/login"]);
  //   // window.location.href = this.appUrlsService.signOutRedirectUrl;
  // }
  //Project Modal
  public addProject(id: any) {
    let tempData: any = {};
    if (id == null || id == undefined) {
      tempData.title = "Add Project";
      tempData.type = "Register";
    } else {
      tempData.title = "Update Project";
      tempData.type = "Update";
      let projectObj = this.Items.find((x) => x.id == id);
      tempData.data = projectObj;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "700px";
    dialogConfig.data = tempData;
    // this.reloadPagination = true;
    const dialogRef = this.dialog.open(CreateProjectComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res) => {
      if (res != "unchanged") {
        this.getAllProjects();
      }
    });
  }
  onLogout(e) {
    if (e) {
      e.preventDefault();
      localStorage.removeItem(this.projectName + "token");
      localStorage.removeItem("projectId");
      localStorage.removeItem("projectName");

      if (!localStorage.getItem(this.projectName + "token")) {
        this.router.navigate(["/auth/login"]);
      }
    }
  }
  changeTheme(isDark) {
    this.document.body.classList.remove("sidebar-light", "sidebar-dark");
    localStorage.setItem(
      "sidebarTheme",
      isDark == true ? "sidebar-dark" : "sidebar-light"
    );
    this.document.body.classList.add(localStorage.getItem("sidebarTheme"));
    this.document.body.classList.remove("settings-open");
    this._dataSharingService.sidebarLogoUrl =
      isDark == true
        ? "assets/images/onstak-logo-white.svg"
        : "assets/images/onstak-logo-dark.svg";
  }
}
